// Constants and helpers shared across the extracted Officers sub-components.
// Keeping them in a small JS module lets the modal + table + grid stay pure
// presentation with the master Officers.jsx page owning state.

export const ROLE_OPTIONS = [
  { value: "guard", label: "Officer" },
  { value: "supervisor", label: "Supervisor" },
  { value: "dispatcher", label: "Dispatcher" },
];

export const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "on_leave", label: "On Leave" },
  { value: "inactive", label: "Inactive" },
  { value: "pending_deactivation", label: "Pending Deactivation" },
  { value: "deactivated", label: "Deactivated" },
];

export const BYTES_PER_KB = 1024;

export const emptyGuard = {
  name: "",
  badge_no: "",
  phone: "",
  email: "",
  role: "guard",
  certifications: [],
  status: "active",
  hire_date: "",
  hourly_rate: 18,
  notes: "",
  deactivation_date: "",
  reactivation_date: "",
  max_weekly_hours: "",
  username: "",
  password: "",
};

/**
 * Derive the effective status from raw `status` + `deactivation_date`.
 * - `deactivated`: deactivation_date set and on/before today.
 * - `pending_deactivation`: deactivation_date set but in the future.
 * - otherwise the raw `status` (defaults to `active`).
 *
 * Filtering by "Deactivated" matches the rows the user actually sees as
 * deactivated — same logic used by the status badge in the table.
 */
export function derivedStatus(g) {
  const dd = g?.deactivation_date;
  if (dd) {
    const today = new Date(); today.setHours(0, 0, 0, 0);
    return new Date(dd) <= today ? "deactivated" : "pending_deactivation";
  }
  return g?.status || "active";
}

export const statusTone = (s) =>
  ({ active: "green", on_leave: "amber", inactive: "default" }[s] || "default");

/** Count how many certs are expired vs nearing expiry (30-day horizon). */
export function summarizeCertExpiry(certs) {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const horizon = new Date(today.getTime() + 30 * 86400 * 1000);
  let expired = 0, nearing = 0;
  (certs || []).forEach((c) => {
    const exp = typeof c === "object" && c.expires_at && !c.no_expiry ? new Date(c.expires_at) : null;
    if (!exp) return;
    if (exp < today) expired += 1;
    else if (exp <= horizon) nearing += 1;
  });
  return { expired, nearing };
}
